import { baseUrl } from "../config/config";
import axios from 'axios';

// get all Users
export const getAllUsers = async () => {
  try {
    const response = await axios.get(`${baseUrl}/users`);
    return response.data;
  } catch (error) {
    console.error('erreur get all Users:', error);
    return error;
  }
}

// get User by Id
export const getUserById = async (id) => {
  try {
    const response = await axios.get(`${baseUrl}/users/${id}`);
    return response.data;
  } catch (error) {
    console.error(`erreur get Users by Id ${id}:`, error);
    return error;
  }
}

// add User
export const addUser = async (user) => {
  try {
    const response = await axios.post(`${baseUrl}/users`, user);
    return response;
  } catch (error) {
    console.error( "erreur lors de l'ajout de l'utilisateur", error);
    return error;
  }
}
